// removed by extract-text-webpack-plugin
module.exports = {"flyout":"styles__flyout___8f_72"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/flyout/styles.css
// module id = XMAh
// module chunks = 2